import { Component, OnInit } from '@angular/core';
import { AbstractControl, FormBuilder, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { ModalController } from '@ionic/angular';

@Component({
  selector: 'app-password-reset',
  templateUrl: './password-reset.page.html',
  styleUrls: ['./password-reset.page.scss'],
  standalone: false
})
export class PasswordResetPage implements OnInit {

  email: string = '';
  verificationCode: string='';
  form = this.fb.group({
    password: ["",Validators.required],
    confirmPassword: ["",Validators.required],
    signOutOption: [false,Validators.required],
  })

  step1: boolean = true;
  step2: boolean = false;
  step3: boolean = false;
  selectedOption: boolean = false;
  showConfirmPassword:boolean = false;
  showPassword:boolean = false;
  constructor(private fb: FormBuilder, private modalController: ModalController) { 
    this.form.get('password')?.addValidators(
      this.passwordValidator('firstName', 'lastName')
    );
  
    this.form.get('password')?.updateValueAndValidity();
  }

  ngOnInit() {
    this.form.statusChanges.subscribe(status => {
      this.selectedOption = status === 'VALID';
    });
  }

  createAccount() {

  }

  checkLogin(){

  }
  closeLogin(){
    this.modalController.dismiss(null, 'cancel');
  }
  get password() {
    return this.form.get('password');
  }
  togglePassword() {
    this.showPassword = !this.showPassword;
  }
  toggleConfirmPassword() {
    this.showConfirmPassword = !this.showConfirmPassword;
  }

  switchTab(tabNo:number){
    if(tabNo == 1) {
      this.step1 = true;
      this.step2 = false;
      this.step3 = false;
    } else if(tabNo == 2) {
      this.step1 = false;
      this.step2 = true;
      this.step3 = false;
    } else if(tabNo == 3) {
      this.step1 = false;
      this.step2 = false;
      this.step3 = true;
    }
  }

  sendEmail(){
    this.switchTab(2);
  }
  verifyOtp(){
    this.switchTab(3);
  }
  resetPassword(){
    window.location.reload();
  }
  passwordValidator(
    firstNameKey: string,
    lastNameKey: string
  ): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const password = control.value;
      if (!password) return null;
  
      const parent = control.parent;
      const firstName = parent?.get(firstNameKey)?.value?.toLowerCase();
      const lastName = parent?.get(lastNameKey)?.value?.toLowerCase();
  
      const errors: any = {};
  
      if (password.length < 8) {
        errors.minLength = true;
      }
  
      if (!/[a-z]/.test(password)) {
        errors.lowercase = true;
      }
  
      if (!/[A-Z]/.test(password)) {
        errors.uppercase = true;
      }
  
      if (!/[0-9]/.test(password)) {
        errors.number = true;
      }
  
      if (
        (firstName && password.toLowerCase().includes(firstName)) ||
        (lastName && password.toLowerCase().includes(lastName))
      ) {
        errors.containsName = true;
      }
  
      return Object.keys(errors).length ? errors : null;
    };
  }

}
